
const PDFBranding = () => {
  return (
    <div className="flex-row align-center justify-center w-full g-1" style={{height:"4.5rem"}}>
      <span className="t-20">❤️</span>
      <h2
        className="t-25"
        style={{ fontSize: "5rem", color: "rgba(58, 86, 142, 0.27)" }}
      >
        OVER LABS
      </h2>
      <div className="flex-col h-full align-start justify-start">
        <span style={{ color: "rgba(58, 86, 142, 0.27)",fontSize:"1.5rem" }}>&copy;</span>
      </div>
    </div>
  );
};

export default PDFBranding;
